import { clsx } from 'clsx';

import { SocialButtons } from '../SocialButtons';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { B2CLoginSocialButtonsProps } from './types';

export const B2CLoginSocialButtons: React.FC<
  React.PropsWithChildren<B2CLoginSocialButtonsProps>
> = ({ className, ...rest }) => (
  <div className={clsx(className, 'flex justify-center')}>
    <SocialButtons {...rest} variant="minimal-2" />
  </div>
);

export default B2CLoginSocialButtons;
